
export default {
  props: ["footerData"],
  data() {
    return {
      imageList: [
        {
          name: "Facebook",
          class: "tabler--brand-facebook",
        },
        {
          name: "Twitter",
          class: "tabler--brand-twitter",
        },
        {
          name: "Pinterest",
          class: "tabler--brand-pinterest",
        },
        {
          name: "Linkedin",
          class: "tabler--brand-linkedin",
        },
        {
          name: "YouTuBe",
          class: "tabler--brand-youtube",
        },
      ],
      shareList: [],
    };
  },
  mounted() {
    let obj = this.footerData.contactShare;
    this.imageList.map(v => {
      v.href = obj[v.name] ? obj[v.name] : v.href || null;
      return v;
    });

    this.shareList = this.imageList.filter(v => v.href);
    this.$forceUpdate();
  },
};
